import processReport from '@/assets/js/report/deviation'
import processDeviationMeasures from '@/assets/js/report/deviation_measure'
export default {
  methods: {
    async genereateReportContent (ids, isMeasure = false, measureTitle = '') {
      if (!ids) ids = []
      let lang = this.$i18n.locale ? this.$i18n.messages[this.$i18n.locale].message : this.$i18n.messages['en'].message
      if (ids) {
        let records = []
        if (isMeasure) {
          records = await this.getDeviationMeasureRecords(ids)
        } else {
          records = await this.getDeviationRecords(ids)
        }
        let translationData = {
          header: {
            number: lang.product.number,
            title: lang.deviations.title,
            category: lang.deviations.category,
            location: lang.deviations.location,
            internalCost: lang.deviations.estimatedInternalCost,
            customerCost: lang.deviations.estimatedCustomerCost,
            severity: lang.deviations.severity,
            deadline: lang.deviations.deadline,
            date: lang.deviations.registert,
            status: lang.tickets.status
          },
          deviation: lang.layout.deviation,
          description: lang.customer.description,
          reason: lang.deviations.reason,
          underlyingReason: lang.deviations.underlying_reason,
          actions: lang.tickets.actions,
          correctiveActions: lang.deviations.corrective_actions,
          effectiveOfMeasures: lang.deviations.effective_of_measures,
          report: lang.deviations.deviation_report,
          order: lang.warehouse.orderRepo,
          salesRef: lang.orders.salesReference,
          measure: lang.deviations.measures,
          measureTitle: lang.deviations.title,
          measureStatus: lang.layout.status,
          measureIncharge: lang.deviations.incharge,
          measureDeadline: lang.deviations.deadline
        }
        let getBase64Content = ''
        if (isMeasure) getBase64Content = processDeviationMeasures(records, translationData, measureTitle)
        else getBase64Content = processReport(records, translationData)
        return getBase64Content
      }
    },
    getDeviationMeasures (deviationid = 0) {
      return new Promise((resolve, reject) => {
        let model = {
          rowsperpage: -1,
          deviationid
        }
        this.$_executeApi('post', 'deviationmeasures/paginate_filter', model)
          .then((response) => {
            let { items } = response.data
            items.map(x => {
              x.deadline = this.$formatter.formatDate(x.deadline, 'DD.MM.YYYY', 'DD.MM.YYYY')
              return x
            })
            resolve(items)
          })
          .catch((err) => {
            console.log(err)
            reject(err)
          })
      })
    },
    getDeviationRecords (ids) {
      return new Promise((resolve, reject) => {
        let model = {
          orderid: this.$route.params.order_id || 0,
          rowsperpage: -1,
          ids
        }
        this.$_executeApi('post', 'deviations/paginate_filter', model)
          .then(async (response) => {
            let { items } = response.data
            var results = []
            for (let i = 0; i < items.length; i++) {
              var x = items[i]
              x.estimated_internal_cost = this.$formatter.replaceDotWithComma(x.estimated_internal_cost)
              x.estimated_customer_cost = this.$formatter.replaceDotWithComma(x.estimated_customer_cost)
              x.created_on = this.$formatter.formatDate(x.created_on, 'DD.MM.YYYY', 'DD.MM.YYYY')
              x.deadline = this.$formatter.formatDate(x.deadline, 'DD.MM.YYYY', 'DD.MM.YYYY')
              x.date = this.$formatter.formatDate(x.date, 'DD.MM.YYYY', 'DD.MM.YYYY')
              x.created_on = this.$formatter.formatDate(x.created_on, 'DD.MM.YYYY', 'DD.MM.YYYY')
              var severityObj = this.$_deviationSeverity
              var severityVal = severityObj.find(y => y.value === x.severity)
              if (severityVal) {
                x.severity_val = severityVal.text || ''
              }
              x.measures = await this.getDeviationMeasures(x.id)
              results.push(x)
            }
            resolve(results)
          })
          .catch((err) => {
            console.log(err)
            reject(err)
          })
      })
    },
    getDeviationMeasureRecords (ids) {
      return new Promise((resolve, reject) => {
        let model = {
          rowsperpage: -1,
          ids
        }
        this.$_executeApi('post', 'deviationmeasures/paginate_filter', model)
          .then(async (response) => {
            let { items } = response.data
            var results = []
            for (let i = 0; i < items.length; i++) {
              var x = items[i]
              x.estimatedinternalcost = this.$formatter.replaceDotWithComma(x.estimatedinternalcost)
              x.estimatedcustomercost = this.$formatter.replaceDotWithComma(x.estimatedcustomercost)
              x.created_on = this.$formatter.formatDate(x.created_on, 'DD.MM.YYYY', 'DD.MM.YYYY')
              x.deadline = this.$formatter.formatDate(x.deadline, 'DD.MM.YYYY', 'DD.MM.YYYY')
              x.date = this.$formatter.formatDate(x.date, 'DD.MM.YYYY', 'DD.MM.YYYY')
              x.created_on = this.$formatter.formatDate(x.created_on, 'DD.MM.YYYY', 'DD.MM.YYYY')
              results.push(x)
            }
            resolve(results)
          })
          .catch((err) => {
            console.log(err)
            reject(err)
          })
      })
    }
  }
}
